<div class="OTP-modal-container" *ngIf="templateDisplay">
  <div class="modal-header">
    <h3 *ngIf="!otpContent?.isLimitReached && templateDisplay == 'MFA'"> {{ "mfa.verificationStep" | cxTranslate }} </h3>
    <h3 *ngIf="!otpContent?.isLimitReached && templateDisplay == 'choice'"> {{ "mfa.verificationChoiceStep" | cxTranslate }} </h3>
    <h3 *ngIf="otpContent?.isLimitReached"> {{ "mfa.verificationLocked" | cxTranslate }} </h3>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <img alt="" width="20" height="20" src="../../assets/icons/{{baseSiteId}}/close.svg">
    </button>
  </div>
  <ng-container *ngIf="templateDisplay == 'MFA'">
    <span *ngIf="!otpContent?.isLimitReached else limitReached">
      <div class="modal-body">
        <ng-container>
          <p *ngIf="selectedChoice == 'e-mail'"> {{ "mfa.verificationEmailSentMsg" | cxTranslate }} </p>
          <p *ngIf="selectedChoice == 'mobile'"> {{ "mfa.verificationSmsSentMsg" | cxTranslate }} </p>
          <p> {{ otpContent?.maskedDestination }} </p>
          </ng-container>
        <div class="mt-3">
          <span class="header" *ngIf="!timedOut"> {{ "mfa.enterDigitMsg" | cxTranslate }} </span>
          <span class="header" *ngIf="timedOut"> {{ "mfa.requestDigitMsg" | cxTranslate }} </span>
          <form [formGroup]="otpForm" (ngSubmit)="continue()">
            <input #input1 formControlName="input1" type="text" class="OTP-input" maxlength="1" id="input1"
              (input)="(input1.value.length == 1 && input2.value.length < 1) ? inputTriggers('validate', input1.value, 2) : ''"
              (paste)="inputTriggers('paste', $event, 0)" (keydown)="inputTriggers('delete', $event, 1)">
            <input #input2 formControlName="input2" type="text" class="OTP-input" maxlength="1" id="input2"
              (input)="(input2.value.length == 1 && input3.value.length < 1) ? inputTriggers('validate', input2.value, 3) : ''"
              (paste)="inputTriggers('paste', $event, 1)" (keydown)="inputTriggers('delete', $event, 2)">
            <input #input3 formControlName="input3" type="text" class="OTP-input" maxlength="1" id="input3"
              (input)="(input3.value.length == 1 && input4.value.length < 1) ? inputTriggers('validate', input3.value, 4) : ''"
              (paste)="inputTriggers('paste', $event, 2)" (keydown)="inputTriggers('delete', $event, 3)">
            <input #input4 formControlName="input4" type="text" class="OTP-input" maxlength="1" id="input4"
              (input)="(input4.value.length == 1 && input5.value.length < 1) ? inputTriggers('validate', input4.value, 5) : ''"
              (paste)="inputTriggers('paste', $event, 3)" (keydown)="inputTriggers('delete', $event, 4)">
            <input #input5 formControlName="input5" type="text" class="OTP-input" maxlength="1" id="input5"
              (input)="(input5.value.length == 1 && input6.value.length < 1) ? inputTriggers('validate', input5.value, 6) : ''"
              (paste)="inputTriggers('paste', $event, 4)" (keydown)="inputTriggers('delete', $event, 5)">
            <input #input6 formControlName="input6" type="text" class="OTP-input" maxlength="1" id="input6"
              (input)="inputTriggers('validate', input6.value, 7)" (paste)="inputTriggers('paste', $event, 5)"
              (keydown)="inputTriggers('delete', $event, 6)">
            <br>
            <p *ngIf="formError" class="error"> {{ "mfa.incorrectError" | cxTranslate }} </p>
            <p *ngIf="timedOut" class="error"> {{ "mfa.requestNewError" | cxTranslate }} </p>
            <div class="mb-3" *ngIf="!timedOut">
              <span> {{ "mfa.timeRemaining" | cxTranslate }} <span> {{ timeRemaining | async | date:'mm:ss' }} </span></span>
            </div>
          </form>
        </div>
      </div>
      <p class="success" *ngIf="requestNewClicked && !timedOut">
        {{ "mfa.newVerificationMsg" | cxTranslate}}{{ selectedChoice }} 
      </p>
      <table class="col-12">
        <tr class="col-12" align="center">
          <button type="submit" *ngIf="!timedOut" class="btn-primary otp-button mb-3" (click)="continue()"
            [disabled]="true && otpForm.invalid || disableContinue">
            {{ "mfa.continuBtn" | cxTranslate }}
          </button>
          <button *ngIf="timedOut" class="btn-primary otp-button mb-3" (click)="requestNew('requestNew', null, true)"
            [disabled]="disableRequestNew">
            {{ "mfa.resendBtn" | cxTranslate }}
          </button>
        </tr>
        <tr class="col-12" align="left" *ngIf="selectedChoice == 'e-mail'">
          <p> {{ "mfa.checkEmailMsg" | cxTranslate }} </p>
        </tr>
        <tr class="col-12" align="left" *ngIf="selectedChoice == 'mobile'">
          <p> {{ "mfa.checkMobileMsg" | cxTranslate }} </p>
        </tr>

        <tr class="col-12" align="center" *ngIf="!timedOut">
          <button class="btn-secondary otp-button" [ngClass]="timerNotif ? '' : 'mb-4'" (click)="requestNew('reset', null, true)"
            [disabled]="disableRequestNew">
            {{ "mfa.requestNewBtn" | cxTranslate }}
          </button>
          <p *ngIf="!timedOut && timerNotif"> {{ "mfa.timeoutMsg" | cxTranslate }} </p>
        </tr>
      </table>
    </span>
  </ng-container>
  
  <ng-container *ngIf="templateDisplay == 'choice'">
    <div class="modal-body">
      <p> {{ "mfa.verifyMessage" | cxTranslate }} </p>
    </div>
    <div class="mt-3">
      <div *ngFor="let choices of otpChoices.methods" class="col-sm-12 d-flex mb-2">
        <input type="radio" class="col-1" [name]="choices.name" [id]="choices.name" [value]="choices.name" [(ngModel)]="selectedChoice" />
        <label [for]="choices.name" class="radio-label col-11"> {{ choices.label + ': ' + choices.value }} </label>
      </div>
    </div>
    <table class="col-12">
      <tr class="col-12" align="center">
        <button type="button" class="btn-primary my-4" (click)="selectChoice()" [disabled]="!selectedChoice || disableChoice">
          {{ "mfa.continuBtn" | cxTranslate }}
        </button>
      </tr>
  </table>
  </ng-container>
</div>


<ng-template #limitReached>
  <div class="modal-body">
    <p> {{ "mfa.limitReachedMsg" | cxTranslate }} </p>
    <p class="secondary-header"> {{ "mfa.needAssistance" | cxTranslate }} </p>
    <p class="tertiary-header mb-0"> {{ "mfa.customerSupport" | cxTranslate }} </p>
    <p class="mb-5"> {{ "mfa.days" | cxTranslate }} <br>
      {{ "mfa.timeFrame" | cxTranslate }} <br>
      <span *ngIf="baseSiteId == 'vsh'"> {{ "mfa.phoneNumberVSH" | cxTranslate }} </span>
      <span *ngIf="baseSiteId == 'vax'"> {{ "mfa.phoneNumberVAX" | cxTranslate }} </span>
    </p>
  </div>
  <table class="col-12">
    <tr class="col-12" align="center">
      <button class="btn-primary otp-button mb-3" (click)="closeModal()">
        {{ "mfa.closeBtn" | cxTranslate }}
      </button>
    </tr>
  </table>
</ng-template>